<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Contact Info"
              icon="fas fa-list"
              buttonLabel="ADD CONTACT"
              buttonIcon="fas fa-plus"
              (buttonClick)="showAddContactModal()">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="siteContacts" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Name</th>
                        <th>Email address</th>
                        <th>Country Code</th>
                        <th>Mobile number</th>
                        <th>Contact Type</th>
                        <th>Notifications Enabled</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contact>
                      <tr [pSelectableRow]="contact">
                        <td>{{contact.contactName}}</td>
                        <td>{{contact.email}}</td>
                        <td>{{contact.countryCode}}</td>
                        <td>{{contact.phoneNumber}}</td>
                        <td>
                          <span *ngIf="!contact.emergencyContact" class="badge badge-pill badge-primary">Admin</span>
                          <span *ngIf="contact.emergencyContact" class="badge badge-pill badge-danger">Incident</span>
                        </td>
                        <td>
                        <p-inputSwitch [(ngModel)]="contact.enabled" (onChange)="updateSiteContactsNotification(contact)"></p-inputSwitch>
                        </td>
                        <td><button type="button" class="btn btn-danger btn-link" (click)="deleteContact(contact)">delete</button></td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="6">No contacts found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator [alwaysShow]="false" [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add a contact -->
<p-dialog header="Add Site Contact" [(visible)]="isAddContactModalShown" modal="true" [baseZIndex]="1000000"
  [style]="{ width: '90vw', maxWidth: '750px' }"
  [draggable]="false"
  [resizable]="false">

  <form [formGroup]="addSiteContactForm" (ngSubmit)="onAddSiteContactFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Contact Name</label>
          <input type="text" class="form-control" formControlName="contactName" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Contact Email Address</label>
          <input type="text" class="form-control" formControlName="email" placeholder="abc123@example.com" />
        </div>
      </div>
      <div class="col-md-12">
        <br>
        And / Or
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <br>
          <label>Mobile Number</label>
          <intl-phone-code-field (onIntlCodeChanged)="onIntlCodeChanged($event)"></intl-phone-code-field>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group radio-group">
          <label>Contact Type:</label>
            <p-radioButton name="contactType" value="ADMIN" label="Admin Contact" formControlName="contactType" inputId="opt1"></p-radioButton>
            <p-radioButton name="contactType" value="EMERGENCY" label="Incident Contact" formControlName="contactType" inputId="opt2" checked></p-radioButton>
        </div>
        <div class="form-group d-flex">
          <label style=" margin: 0 25px 0 0;">Notifications Enabled: </label>
          <div>
            <p-inputSwitch formControlName="enabled"></p-inputSwitch>
          </div>
        </div>
        <p class="font-info-blue"><i class="fas fa-info-circle"></i>&nbsp;Admin Contacts are notified when workers check on/off site or when waypoints/expected check off times are missed.</p>
        <p class="font-info-blue">Incident Contacts are notified when workers submit an incident form on the Skylark mobile app</p>
      </div>
      <div class="col-md-12" *ngIf="errorAlerts.length > 0">
        <p-messages [(value)]="errorAlerts"></p-messages>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onAddSiteContactFormSubmit()" [disabled]="!addSiteContactForm.valid" class="my-2 btn btn-round btn-sm btn-success">Add Contact</button>
    <button type="button" (click)="isAddContactModalShown = false" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
  </p-footer>
</p-dialog>
